



























import Vue from "vue";
import PortalVue from "portal-vue";
import ClickOutside from "vue-click-outside";
import { sceneStream, slideStream } from "@/streams";

import { menu } from "@/constant";
import buildHash from "@/utils/buildHash";

Vue.use(PortalVue);

export default Vue.extend({
  directives: {
    ClickOutside
  },
  mounted() {
    sceneStream.subscribe(v => {
      this.scene = v;
    });
    slideStream.subscribe(v => {
      this.slide = v;
    });
    // sceneChangeStream.subscribe(() => {
    //   this.hidedrawer()
    // })
  },
  methods: {
    handleActive(item: any) {
      if (!item.pos) return;
      console.info(this.scene, this.slide, 57);
      const scene = item.pos.scene;
      const slide = item.pos.slide || 0;
      return scene === this.scene && slide === this.slide;
    },
    handleclick(item: any) {
      if (!item.pos) return;
      const scene = item.pos.scene;
      const slide = item.pos.slide;
      return buildHash(scene, slide);
    },
    showdrawer() {
      this.toggle = true;
    },
    hidedrawer(e?: MouseEvent) {
      if (e?.target !== this.$refs.menubtn) {
        this.toggle = false;
      }
    }
  },
  data() {
    return {
      menu: menu.reduce((iter, now) => {
        const scene = now.idx;
        const type = now.type;
        const detail = now.title.join("");
        if (scene === -1) {
          iter.push({ type: "gap", title: detail + " /" });
        } else if (type.indexOf("tab") > -1) {
          (now.groups || []).forEach((v: any, idx: any) => {
            iter.push({
              type: "section",
              title: v.title.join(""),
              pos: { scene, slide: idx }
            });
          });
        } else if (type === "showcase") {
          iter.push({ type: "section", title: "优秀稿件欣赏", pos: { scene } });
        } else {
          iter.push({ type: "section", title: detail, pos: { scene } });
        }
        return iter;
      }, [] as any[]),
      toggle: false,
      scene: 0,
      slide: 0
    };
  }
});
